import { h, createApp } from "vue";
import singleSpaVue from "single-spa-vue";

import vuetify from "./guac-layout/plugins/vuetify";
import { setInterfaces } from "./guac-layout/helpers/useInterface";
import HeaderComponent from "./guac-layout/components/HeaderComponent.vue";
import { getStandaloneInterfaces, reportException } from "./interfaces";

const vueLifecycles = singleSpaVue({
  createApp,
  appOptions: {
    render() {
      // @ts-ignore
      setInterfaces(window.interfaces || this.interfaces || getStandaloneInterfaces());

      return h(HeaderComponent);
    },
  },
  handleInstance(app) {
    app.use(vuetify);
    app.config.errorHandler = (err: Error) => {
      console.error(err);
      void reportException(err);
    };
  },
});

export const bootstrap = vueLifecycles.bootstrap;
export const mount = vueLifecycles.mount;
export const unmount = vueLifecycles.unmount;
